import { api } from './client';

/**
 * Subset of `/api/me` that admin app cares about.  The backend returns more
 * (mobileDefaultTab, etc.) but admin ignores customer-only preferences.
 */
export interface MeProjection {
  id: string;
  email: string;
  username: string;
  name: string;
  avatarUrl: string | null;
  isSuperadmin?: boolean;
}

export async function fetchMe(): Promise<MeProjection> {
  return api<MeProjection>('/api/me');
}
